import React from 'react'
import { useIntl } from 'react-intl'

import {
  MessageBox,
  MESSAGE_BOX_VARIANT_WARNING,
  MESSAGE_BOX_VARIANT_DANGER
} from 'mailup-web-components'
import {
  PECPLUS_STATUS_IN_PROGRESS_DESCR,
  PECPLUS_STATUS_ERROR_DESCR
} from 'Constants'

export const WarningMessage = ({
  idSending,
  error,
  severity,
  pecPlusStatus
}) => {
  const intl = useIntl()

  let messageId = ''
  let variant = MESSAGE_BOX_VARIANT_WARNING

  if (pecPlusStatus === PECPLUS_STATUS_IN_PROGRESS_DESCR) {
    messageId = 'Load.PecPlus.WarinigConfingInProgress'
  }

  if (pecPlusStatus === PECPLUS_STATUS_ERROR_DESCR) {
    messageId = 'Load.Common.ConfigPecError'
    variant = MESSAGE_BOX_VARIANT_DANGER
  }

  if (error) {
    messageId = error
    if (severity === 'danger') {
      variant = MESSAGE_BOX_VARIANT_DANGER
    }
  }

  return messageId ? (
    <MessageBox variant={variant}>
      {intl.formatMessage({ id: messageId })}
    </MessageBox>
  ) : null
}
